import AddIcon from '@mui/icons-material/Add'
import { Box, Button } from '@mui/material'
import { useState } from 'react'
import AddClientDialog from '../components/AddClientDialog'
import ClientsList from '../components/ClientsList'
import PageHeader from '../components/PageHeader'
import { useDocumentTitle } from '../hooks/useDocumentTitle'

export default function ClientsPage() {
  useDocumentTitle('Clients')
  const [newFormDialogOpen, setNewFormDialogOpen] = useState(false)

  const handleAddClick = () => {
    setNewFormDialogOpen(true)
  }
  const handleClose = () => {
    setNewFormDialogOpen(false)
  }

  return (
    <Box display="flex" flexDirection="column" flex="1">
      <PageHeader
        title="Clients"
        toolbarChildren={
          <Button variant="contained" color="secondary" onClick={handleAddClick} startIcon={<AddIcon />}>
            Add a Client
          </Button>
        }
      />
      <ClientsList onAddClick={handleAddClick} />
      <AddClientDialog onClose={handleClose} dialogProps={{ open: newFormDialogOpen }} />
    </Box>
  )
}
